import omit from 'lodash/omit';

import * as groupActions from 'actions/group';

export const defaultState = {
  groups: {},
  selectedGroups: {},
  total: 0,
  currentGroup: {},
};

export default function groupReducer(state = defaultState, action) {
  switch (action.type) {
    case groupActions.GROUP_SELECT: {
      const { index, id } = action.payload;

      return {
        ...state,
        selectedGroups: {
          ...state.selectedGroups,
          [id]: state.groups[index],
        },
      };
    }
    case groupActions.GROUP_SELECT_MANY: {
      return {
        ...state,
        selectedGroups: groupActions.concatGroups(
          state.selectedGroups,
          action.payload.groups,
        ),
      };
    }
    case groupActions.GROUP_UNSELECT: {
      const { id } = action.payload;
      const { selectedGroups } = state;

      const toBeRemovedGroup = Object.keys(selectedGroups).filter(
        index => selectedGroups[index].id === id,
      );

      const newSelectedGroups = omit(state.selectedGroups, toBeRemovedGroup);
      const reindexedNewSelectedGroups =
        groupActions.reindexGroups(newSelectedGroups);

      return {
        ...state,
        selectedGroups: {
          ...reindexedNewSelectedGroups,
        },
      };
    }
    case groupActions.GROUP_UNSELECT_MANY: {
      const { groups } = action.payload;
      const { selectedGroups } = state;

      const toBeRemovedUuids = Object.keys(groups).map(k => groups[k].id);
      const toBeRemovedGroups = Object.keys(selectedGroups).filter(k =>
        toBeRemovedUuids.includes(selectedGroups[k].id),
      );

      const newSelectedGroups = omit(state.selectedGroups, toBeRemovedGroups);
      const reindexedNewSelectedGroups =
        groupActions.reindexGroups(newSelectedGroups);

      return {
        ...state,
        selectedGroups: {
          ...reindexedNewSelectedGroups,
        },
      };
    }
    case groupActions.GROUP_UNSELECT_ALL:
      return {
        ...state,
        selectedGroups: {},
      };
    case groupActions.GROUP_CHANGE_FILTER_SUCCESS: {
      const newGroups = action.payload.data.reduce((groups, item, index) => {
        const groupObj = groups;
        groupObj[index] = item;
        return groupObj;
      }, {});
      const { groups, ...restState } = state;
      return {
        ...restState,
        groups: newGroups,
        resetGroups: true,
        total: action.payload.total,
      };
    }
    case groupActions.GET_GROUPS_SUCCESS: {
      const {
        startIndex,
        payload: { data, total },
      } = action;
      const newGroups = data.reduce((groups, item, index) => {
        const groupObj = groups;
        groupObj[startIndex + index] = item;
        return groupObj;
      }, {});

      return {
        ...state,
        groups: {
          ...state.groups,
          ...newGroups,
        },
        resetGroups: false,
        total,
      };
    }
    case groupActions.CURRENT_GROUP_SET_TIMEZONE: {
      const { timezone, timezoneLabel } = action.payload;

      return {
        ...state,
        currentGroup: {
          ...state.currentGroup,
          timezone,
          timezoneLabel,
        },
      };
    }
    case groupActions.CURRENT_GROUP_SET_HAS_SITE_HOLIDAY: {
      return {
        ...state,
        currentGroup: {
          ...state.currentGroup,
          hasSiteHoliday: action.payload,
        },
      };
    }
    case groupActions.CURRENT_GROUP_SET_UUID: {
      return {
        ...state,
        currentGroup: {
          ...state.currentGroup,
          uuid: action.payload,
        },
      };
    }
    default:
      return state;
  }
}
